import { HttpClient } from '@angular/common/http';

import { Injectable } from '@angular/core';
import { ApiUrl } from '../api-url.service';
import { Observable } from 'rxjs';
import { AppInjector } from '../../app-injector';

import { map } from 'rxjs/operators';

@Injectable()
export class FileService {
  private url = '/api/v1/upload/s3';
  http: HttpClient;
  apiUrl: ApiUrl;

  constructor(httpClient: HttpClient, apiUrl: ApiUrl) {
    this.http = httpClient;
    this.apiUrl = apiUrl;
  }

  upload(file, name): Observable<any> {
    const formData: FormData = new FormData();
    formData.append('files', file, name);
    return this.http.post(this.apiUrl.getApiUrl(this.url), formData).pipe(map((response: any) => response));
  }

  rotate(url): Observable<any> {
    const data = {
      image_url: url
    };
    return this.http.post(this.apiUrl.getApiUrl(this.url) + '/rotate', data).pipe(map((response: Response) => response));
  }
}
